const query = {
    baseURL: 'https://zins0u5gb7.execute-api.eu-central-1.amazonaws.com/v3_0_01',
    path: {
      currentWeather: '/videowall/weather/current',
      forecastWeather: '/videowall/weather/forecast',
      satisfaction: '/videowall/satisfaction',
      verticalSla: '/videowall/vertical_sla',
      mapConfiguration: '/videowall/map_configuration',
      layoutZonaA: '/videowall/layout_zona_a',
      layoutZonaB: '/videowall/layout_zona_b',
      layoutZonaC: '/videowall/layout_zona_c',
      layoutZonaD: '/videowall/layout_zona_d',
      layoutZonaE: '/videowall/layout_zona_e',
      incidents: '/videowall/incidents',
      operationStatus: '/videowall/operation_status',
      realtimeBus: '/videowall/realtime_bus',
      realtimeTrips: '/videowall/realtime_trips',
      globalConfiguration: '/videowall/global_configuration',
      tableIncidents: '/videowall/table_incidents'
    }
}
  
export default query;